import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const skuTypeWiseGroupServices = {
	listSkuTypeWiseGroups,
	createSkuTypeWiseGroup,
	updateSkuTypeWiseGroup,
	deleteSkuTypeWiseGroup,
};

function listSkuTypeWiseGroups() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(endpoints.SKUTYPE_WISE_GROUP_LIST, requestOptions).then(handleResponse);
}

function createSkuTypeWiseGroup(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req.data),
	};
	return fetch(endpoints.SKUTYPE_WISE_GROUP_CREATE, requestOptions).then(handleResponse);
}

function updateSkuTypeWiseGroup(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req.data),
	};
	return fetch(endpoints.SKUTYPE_WISE_GROUP_UPDATE, requestOptions).then(handleResponse);
}

function deleteSkuTypeWiseGroup(req) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(req.data),
	};
	return fetch(endpoints.SKUTYPE_WISE_GROUP_DELETE, requestOptions).then(handleResponse);
}

export default skuTypeWiseGroupServices;
